import React from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import logo from '../../../resources/logo.svg'
import { routes } from '../../../consts'

import './Header.css'

export const Header = ({ isLogoClickable = true }) => {
  const dispatch = useDispatch()

  return (
    <div className="header">
      <div className={`logo-container ${isLogoClickable ? '' : 'not-hoverable'}`}>
        <img
          data-name={'logo'}
          src={logo}
          alt=""
          onClick={() => {
            if (isLogoClickable) {
              dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
            }}
          }
          className="logo-img trackable"
        />
      </div>
    </div>
  )
}

export default Header
